/**
 * Hand-written SEO title and meta description of the product-line (category) and subcategory pages,
 * imported by scripts/import-seo-meta.ts into src/data/seo/<language>.json (one file per language,
 * keyed by category or subcategory id, e.g. "1" or "1_3"). Plain text in their own language, not
 * translation keys: they're written to length limits per language, not translated term by term.
 */
export type SeoMeta = { title: string; description: string };
export type SeoMetaTable = Record<string, SeoMeta>;

const loaders = import.meta.glob<{ default: SeoMetaTable }>('../../data/seo/*.json');
const cache = new Map<string, Promise<SeoMetaTable>>();

/** The texts of one language, loaded on first use (its own chunk). A language without a file has none. */
export async function loadSeoMeta(language: string): Promise<SeoMetaTable> {
  let loaded = cache.get(language);
  if (!loaded) {
    const loader = loaders[`../../data/seo/${language}.json`];
    loaded = loader ? loader().then((module) => module.default) : Promise.resolve({});
    cache.set(language, loaded);
  }

  return loaded;
}
